import React from 'react';
import Icon from '../../../components/AppIcon';

const BrandingHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-2xl mb-4">
        <Icon name="Layers" size={32} color="var(--color-primary)" />
      </div>
      <h1 className="text-3xl font-bold text-text-primary mb-2">EpoxyViz Pro</h1>
      <p className="text-text-secondary">Admin Management System</p>
    </div>
  );
};

export default BrandingHeader;